import { useTranslation } from 'react-i18next';
import UtmsChip from '@shared/components/ui/UtmsChip';
import { TEST_RESULT_CONFIG } from '@pages/testruns/constants/testrunsConstants';

const TestResultChip = ({ result, sx = {}, ...props }) => {
    const { t } = useTranslation();

    const key = result?.toLowerCase();
    const config = key && TEST_RESULT_CONFIG[key];

    const { color, variant = 'filled', sx: configSx } = config ?? {};

    return config ? (
        <UtmsChip
            color={color}
            label={t(key, { lng: 'en' })}
            variant={variant}
            sx={{ ...configSx, ...sx }}
            {...props}
        />
    ) : (
        <>–</>
    );
};

export default TestResultChip;
